import React, { Fragment } from 'react';
import { IconChevronLeft, IconChevronRight } from '@at/design-system-icons';
import * as Styled from '../../carousel-lite.styled';
import { dataAttrGUI } from '@at/formatter-utils';
export var CarouselArrows = function (_a) {
    var _b, _c;
    var shouldShowArrows = _a.shouldShowArrows, loopScroll = _a.loopScroll, isOnFirstSlide = _a.isOnFirstSlide, totalSlides = _a.totalSlides, currentSlideIndex = _a.currentSlideIndex, isOnFinalSlide = _a.isOnFinalSlide, shouldRemoveDisabledArrow = _a.shouldRemoveDisabledArrow, shouldDisablePreviousButton = _a.shouldDisablePreviousButton, shouldDisableNextButton = _a.shouldDisableNextButton, arrowPositionResponsive = _a.arrowPositionResponsive, trackingCallback = _a.trackingCallback, handleSlideMove = _a.handleSlideMove;
    if (!shouldShowArrows)
        return null;
    var goToSlideText = "Go to slide ";
    var buttonPreviousArrowTitle = loopScroll && isOnFirstSlide
        ? "".concat(goToSlideText, " ").concat(totalSlides)
        : isOnFirstSlide
            ? "No previous slide available"
            : "".concat(goToSlideText, " ").concat(currentSlideIndex);
    var buttonNextArrowTitle = loopScroll && isOnFinalSlide
        ? "".concat(goToSlideText, " 1")
        : isOnFinalSlide
            ? "No next slide available"
            : "".concat(goToSlideText, " ").concat(currentSlideIndex + 2);
    var shouldRemovePreviousButton = shouldRemoveDisabledArrow && shouldDisablePreviousButton;
    var shouldRemoveNextButton = shouldRemoveDisabledArrow && shouldDisableNextButton;
    var handleArrowClick = function (event, moveToSlideIndex) {
        event.preventDefault();
        event.stopPropagation();
        trackingCallback === null || trackingCallback === void 0 ? void 0 : trackingCallback();
        if (moveToSlideIndex === currentSlideIndex)
            return;
        handleSlideMove(moveToSlideIndex);
    };
    return (React.createElement(Fragment, null,
        !shouldRemovePreviousButton ? (React.createElement(Styled.ArrowPrevious, (_b = { "aria-label": buttonPreviousArrowTitle, disabled: shouldDisablePreviousButton, onClick: function (event) { return handleArrowClick(event, currentSlideIndex - 1); }, arrowPosition: arrowPositionResponsive }, _b[dataAttrGUI] = 'carousel-lite-prev-arrow', _b),
            React.createElement(IconChevronLeft, { title: "", size: 18 }))) : null,
        !shouldRemoveNextButton ? (React.createElement(Styled.ArrowNext, (_c = { "aria-label": buttonNextArrowTitle, disabled: shouldDisableNextButton, onClick: function (event) { return handleArrowClick(event, currentSlideIndex + 1); }, arrowPosition: arrowPositionResponsive }, _c[dataAttrGUI] = 'carousel-lite-next-arrow', _c),
            React.createElement(IconChevronRight, { title: "", size: 18 }))) : null));
};
